/// <amd-module name="Artifacts/Ivy/redux/Module" />
import { PackageModule } from "Artifacts/Package/redux";
import { ISagaModule } from "redux-dynamic-modules-saga";

const _IvyModule: ISagaModule<Record<string, never>> = {
  id: "ivy-protocol-module",
  reducerMap: {},
};

export const IvyModule = [PackageModule, _IvyModule];
